import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=9831d9d8"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports